/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_All_CitiesInputs */



/**
* | output |
* | --- |
* | "All cities" |
*
* @param {Rankings_All_CitiesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_all_cities = /** @type {((inputs?: Rankings_All_CitiesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_All_CitiesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les villes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las ciudades")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as cidades")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le città")
	return /** @type {LocalizedString} */ ("All cities")
});